import { __assign } from "tslib";
import React, { useMemo } from 'react';
import { rgba } from 'polished';
import { RowContainer } from './body.styles';
export var Body = function (_a) {
    var page = _a.page, columnsWidth = _a.columnsWidth, getTableBodyProps = _a.getTableBodyProps, prepareRow = _a.prepareRow, backgroundColor = _a.backgroundColor, typography = _a.typography, _b = _a.activeColumns, activeColumns = _b === void 0 ? [] : _b, disableValuesSelection = _a.disableValuesSelection, _c = _a.isEditMode, isEditMode = _c === void 0 ? false : _c, onCellClick = _a.onCellClick, onCellMouseEnter = _a.onCellMouseEnter, onCellMouseLeave = _a.onCellMouseLeave;
    var rgbaBackground = useMemo(function () { return rgba(backgroundColor, 0.3); }, [
        backgroundColor,
    ]);
    return (React.createElement("tbody", __assign({}, getTableBodyProps()), page.map(function (row) {
        prepareRow(row);
        return (React.createElement(RowContainer, __assign({ key: row.getRowProps().key, disableValuesSelection: disableValuesSelection, mainColor: backgroundColor, enableHover: !isEditMode }, (!isEditMode && {
            whileHover: { backgroundColor: rgbaBackground },
        })), row.cells.map(function (cell, i) {
            var _a = cell.column, columnId = _a.id, columnType = _a.type, rowId = cell.row.id;
            return cell.render('Cell', {
                key: rowId + "_" + columnId,
                width: columnsWidth[i] ? columnsWidth[i] : null,
                typography: typography,
                isActive: activeColumns.includes(i),
                editMode: isEditMode,
                onCellClick: function (e, value) {
                    return onCellClick(e, {
                        columnName: columnId,
                        columnType: columnType,
                        rowId: rowId,
                        value: value,
                        idx: i,
                    });
                },
                onCellMouseEnter: function (e) {
                    return onCellMouseEnter && onCellMouseEnter(e, i);
                },
                onCellMouseLeave: function (e) {
                    return onCellMouseLeave && onCellMouseLeave(e, i);
                },
            });
        })));
    })));
};
